export default __webpack_public_path__ + "images/left-side.1fd0ba522378f836b3bc672552330e5b.svg";